import { render, staticRenderFns } from "./com-form-region.vue?vue&type=template&id=418ae5c6&"
import script from "./com-form-region.vue?vue&type=script&lang=js&"
export * from "./com-form-region.vue?vue&type=script&lang=js&"
import style0 from "./com-form-region.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports